/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';

export type SvuWorkerDocsDelegatePartialUpdateRequest = {} | null | undefined;
export type SvuWorkerDocsDelegatePartialUpdateResponse = any;

export type SvuWorkerDocsDelegatePartialUpdateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this doc.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * PATCH /dmx-server/svu_worker_docs/{id}/delegate/
 *
 * ```yaml
 * operationId: svu_worker_docs_delegate_partial_update
 * tags:
 *   - svu_worker_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const svuWorkerDocsDelegatePartialUpdateOperation = ({
  id,
  ...rest
}: SvuWorkerDocsDelegatePartialUpdateQuery) =>
  ({
    method: 'PATCH',
    path: `/dmx-server/svu_worker_docs/${id}/delegate/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'PATCH';
    path: string & { _templateUrl: '/dmx-server/svu_worker_docs/{id}/delegate/' };
  };

/**
 * PATCH /dmx-server/svu_worker_docs/{id}/delegate/
 *
 * ```yaml
 * operationId: svu_worker_docs_delegate_partial_update
 * tags:
 *   - svu_worker_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const svuWorkerDocsDelegatePartialUpdate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: SvuWorkerDocsDelegatePartialUpdateQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<any>> => {
  const operation = svuWorkerDocsDelegatePartialUpdateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'PATCH',
    request,
    onUploadProgress,
    cancelToken,
  );
};
